import { render, staticRenderFns } from "./pupilmodal.vue?vue&type=template&id=5d1c567a&"
import script from "./pupilmodal.vue?vue&type=script&lang=js&"
export * from "./pupilmodal.vue?vue&type=script&lang=js&"
import style0 from "./pupilmodal.vue?vue&type=style&index=0&id=5d1c567a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports